import { StyledChart } from "./components/chart";
import ScrollToTop from "./components/scroll-to-top";
import { StorageKeys } from "./enums/StorageKeys.enum";
import LoginPage from "./pages/LoginPage";
import Router from "./routes";
import ThemeProvider from "./theme";

export default function App() {
	const token = localStorage.getItem(StorageKeys.token);
	if (!token) {
		return (
			<ThemeProvider>
				<LoginPage />
			</ThemeProvider>
		);
	}
	return (
		<ThemeProvider>
			<ScrollToTop />
			<StyledChart />
			<Router />
		</ThemeProvider>
	);
}
